import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=45cd7366&scoped=true&"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderList.vue?vue&type=style&index=0&id=45cd7366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd7366",
  null
  
)

export default component.exports